import React from 'react';
import cn from 'classnames';

import {
  PRIVACY_POLICY_LINK,
  RETURN_POLICY_LINK,
  TERMS_OF_SERVICE_LINK,
} from '../../../../constants/links';
import Checkbox from '../../../../components/form/Checkbox';

import styles from './styles.module.scss';

const ActivationTerms = ({ termsChecked, toggleTermsChecked }) => {
  return (
    <div className={styles.wrapper}>
      <Checkbox
        className={styles.checkbox}
        value={termsChecked}
        onChange={toggleTermsChecked}
        label={null}
      />
      <span className={cn('text-xs', styles.text)}>
        I have read and agree to the{' '}
        <a
          className={styles.link}
          href={TERMS_OF_SERVICE_LINK}
          rel="noopener noreferrer"
          target="_blank"
        >
          terms of service
        </a>
        ,{' '}
        <a
          className={styles.link}
          href={PRIVACY_POLICY_LINK}
          rel="noopener noreferrer"
          target="_blank"
        >
          privacy policy
        </a>{' '}
        and{' '}
        <a
          className={styles.link}
          href={RETURN_POLICY_LINK}
          rel="noopener noreferrer"
          target="_blank"
        >
          return policy
        </a>
        .
      </span>
    </div>
  );
};

export default ActivationTerms;
